<template>
    <div class="row gutters w-100">
        <h5 class="col-12" v-if="this.validatePermissions('Dashboard:resume')">Resumo de Reservas
            {{ getNameAllotment() }} </h5>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex w-100 overflow-auto"
             v-if="this.validatePermissions('Dashboard:resume')" style="gap: 10px">
            <div v-for="(iten, key) in this.resumReserve.reservesByStatus" :key="key" class="flex-grow-1 "
                 style="min-width: max-content">
                <div class="info-stats4">
                    <div class="info-icon">
                        <i class="icon-lock-open"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ iten.total }}</h3>
                        <p>{{ iten.statusName }}</p>
                    </div>
                </div>
            </div>
            <div class="flex-grow-1 ">
                <div class="info-stats4">
                    <div class="info-icon">
                        <i class="icon-layers2"></i>
                    </div>
                    <div class="sale-num">
                        <h3>{{ this.resumReserve.reservesTotal }}</h3>
                        <p>Total</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import permission from '../../../components/permission';
import {mapState} from 'vuex';

export default {
    name: "cardsResumReserves",
    mixins: [permission],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    props:['allotmentId', 'resumReserve'],
    computed: {
        ...mapState({
            allotmentsStore: 'allotments',
        }),
    },
    methods:{
        getNameAllotment() {
            let name = '';
            if (this.allotmentsStore?.length) {
                name = this.allotmentsStore.find(i => i.id === this.allotmentId)?.text;
            }
            if (!name) return "";
            return `- ${name}:`;
        },
    }
}
</script>

<style scoped>

</style>